import { render, staticRenderFns } from "./ChatDetailTable.vue?vue&type=template&id=613e2717"
import script from "./ChatDetailTable.vue?vue&type=script&lang=js"
export * from "./ChatDetailTable.vue?vue&type=script&lang=js"
import style0 from "./ChatDetailTable.vue?vue&type=style&index=0&id=613e2717&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports